import { Component, ComponentInterface, h, Host, Prop } from '@stencil/core';
import { Icon } from '../../../shared/icons';

@Component({
  tag: 'wb-modal-header',
  styleUrl: './modal-header.scss',
  shadow: false,
})
export class ModalHeader implements ComponentInterface {
  /** Label to show within the "wb-modal__back-button" */
  @Prop()
  public backButtonLabel: string = 'Back';

  /** Aria label for the modal close button */
  @Prop()
  public closeButtonLabel: string = 'Close';

  /** Recommended for nested modals with level > 1 */
  @Prop()
  public showBackButton: boolean = false;

  public render(): void {
    return (
      <Host>
        {this.showBackButton && (
          <button type="button" class="wb-button wb-button--tertiary wb-button--small wb-modal__back-button" aria-hidden={this.showBackButton ? 'false' : 'true'}>
            <wb-icon class="wb-button__icon" aria-hidden="true" name={Icon.BdsChevronLeft_24} flip-rtl />
            {this.backButtonLabel}
          </button>
        )}
        <button type="button" class="wb-round-button wb-round-button--small wb-modal__close-button" aria-label={this.closeButtonLabel}>
          <wb-icon class="wb-round-button__icon" name={Icon.BdsClose_24} aria-hidden="true" />
        </button>
      </Host>
    );
  }
}
